import request from "@/utils/request";

export async function product(data) {
    let headers = {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
    };
    return request({
      url: "/products",
      method: "get",
      data,
      headers: headers,
    });
}
// 产品详情
export async function Lists(data) {
  let headers = {
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
  };
  return request({
    url: "/products/"+data,
    method: "get",
    data,
    headers: headers,
  });
}
// 关于我们
export async function singlePage(data) {
  let headers = {
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
  };
  return request({
    url: "/single-page/"+data,
    method: "get",
    data,
    headers: headers,
  });
}

export async function brandstory(data) {
  let headers = {
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
  };
  return request({
    url: "/brand-story",
    method: "get",
    params:{
     ...data
    },
    headers: headers,
  });
}
// 常见问题详情
export async function faqs(data) {
  
  let headers = {
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
  };
  return request({
    url: "/faqs/"+data,
    method: "get",
    params:{
     ...data
    },
    headers: headers,
  });
}
// 常见问题列表
export async function faqsList(data) {
  
  let headers = {
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
  };
  return request({
    url: "/faq-cates",
    method: "get",
    params:{
     ...data
    },
    headers: headers,
  });
}

